<template>
  <div>
    <CrudList
      title="Orders"
      storeName="Orders"
      parentStoreName="Users"
      parentUrlKey="user_id"
      :canAdd="false"
      :canEdit="true"
      :canDelete="true"
      :filters="filters_obj"
      canSearch
      sortable
    >
      <template v-slot:date_sales="{ options }">
        <v-row>
          <v-col></v-col>
          <v-col cols="6">
            <v-select
                v-model="status_selected"
                :items="getItems()"
                item-text="name"
                item-value="status"
                label="Status"
            ></v-select>
          </v-col>
          <v-col cols="12" class="col-3 vertical-middle">
            <v-btn
                    depressed
                    color="primary"
                    class="mt-5"
                    v-on:click="exportBtn"
            >
              <v-icon left>fas fa-download</v-icon>
              Export as
            </v-btn>
          </v-col>
        </v-row>
      </template>
      <template v-slot:date_timezone="{item}">
        {{ item && item.date_timezone?formatDate(item.date_timezone,'MM-DD-YYYY HH:mm:ss'):item.createdAt }}
      </template>
      <template v-slot:store_id="{ item }">
        {{(item.store)? item.store.name:''}}
      </template>
      <template v-slot:note="{ item }">
        {{(item.notes && item.notes.length > 0)? item.notes[0].note:''}}
      </template>
      <template v-slot:note_status="{ item }">
        {{(item.notes && item.notes.length > 0)? $store.state['Orders'].note_statuses[item.notes[0].status]:''}}
      </template>
      <template v-slot:status="{ item }" >
        <tr>
          <td :style="{'background-color':colorStatus(item.color)}">
            {{ item.status && item.status === 'delivered' ? 'confirmed' : item.status }}
          </td>
        </tr>        
      </template>
      <template v-slot:total="{ item }">
          {{ !isNaN(item.total) ? parseFloat(item.total).toFixed(2) :'' }}
      </template>
      <template v-slot:sub_total="{ item }">
        {{ !isNaN(item.sub_total) ? parseFloat(item.sub_total).toFixed(2) :'' }}
      </template>
      <template v-slot:discount="{ item }">
        {{ !isNaN(item.discount) ? parseFloat(item.discount).toFixed(2) :'' }}
      </template>
      <template v-slot:products_actions="{ item }">
        <v-btn
            color="info"
            @click="$router.push('/admin/users/' +$route.params.user_id+ '/orders/' + item.id + '/order_products')"
        >Items
        </v-btn>
      </template>

      <template v-slot:guard_id="{ item }">
        <v-row v-if="item && item.guard">
          <v-col>
            <h4>{{ item.guard.fullname }}</h4>
            <div>
              <span>{{ item.guard.email }}</span>
            </div>
          </v-col>
        </v-row>
        <v-row v-else>
          <v-col>
          <h4>Not found Guard</h4>
          </v-col>
        </v-row>
      </template>
    </CrudList>
  </div>
</template>

<script>
  import CrudList from "@/components/Crud/CrudList";
  import { mapActions, mapState } from "vuex";
  import { config } from "@/config/constants.js";
  import moment from "moment";

  export default {
    components: {CrudList},
    async created() {
      if (this.$route.params.user_id) {
        this.user_id= this.$route.params.user_id;
      }

      
    },
    data:()=>({
      items:[
          {
            status:['pending','delivered'],
            name:'View All'
          },
          {
            status:'pending',
            name:'Pending'
          },
          {
            status:'delivered',
            name:'Confirmed'
          }],
      status_selected:null,
      filters_obj:{},
      token:'',
      user_id:'',
      data:{
        status:''
      }
    }),
    watch:{
      async status_selected(val){
        if(val){
          this.filters_obj = {
            ...this.filters_obj,
            user_id:this.user_id,
            status: this.status_selected
          }
        }
      }

    },
    async mounted(){
    },
    methods:{
      formatDate: (date, format = "H:mm:ss MM/DD/YYYY") =>
          moment(date).utc().format(format),
      exportBtn() {
        const self = this;
        self.token =  self.$store.state["Authenticate"].token;
console.log("holaa");
        const queryString = Object.keys(self.filters_obj)
                .map(key => key + "=" + self.filters_obj[key])
                .join("&");
        window.location.href =
                config.api_url +
                'orders' +
                "?format=csv&" +
                queryString +
                "&authorization=" +
                self.token+
            "&user_id="+this.user_id
        ;
      },
      getItems(){
        return this.items;
      },
      colorStatus(color){
        return color;
      }
    },    
  };
</script>
